module.exports = __webpack_public_path__ + "img/mind_icon_number_6.be226e5e.png";